import React, { lazy, Suspense } from "react";

const LazyDashboard = lazy(() => import("./layout"));

const Layout = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => {
  return (
    <Suspense fallback={<div></div>}>
      <LazyDashboard />
    </Suspense>
  );
};

export default Layout;
